var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',[_c('div',{staticClass:"content"},[(_vm.msgInfo.title)?_c('h4',[_vm._v(_vm._s(_vm.msgInfo.title))]):_vm._e(),_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.msgInfo.sendTime))]),_c('p',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msgInfo.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }